import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineV2"
import { useCheckRoutingInfoQueryCache } from "#/components/carrot-plans/shared/useQueryRoutingInfo"
import useBenefit from "../../../dynamic-content/hooks/useGetBenefit"
import { Journey } from "#/components/carrot-plans/types/journey"
import { isNcqaQualifiedJourneyStage } from "#/components/carrot-plans/types/journeyStage"
import { HelpfulOption } from "#/components/carrot-plans/most-helpful-options/helpfulOption"
import { RoutingInfo } from "#/types/routingInfo"

function shouldShowGoalTimeframe(routingData: RoutingInfo, ivfRequirementsApply: boolean): boolean {
  const isAssistedReproduction = routingData?.journey === Journey.ASSISTED_REPRODUCTION
  const isQualifyingStage = isNcqaQualifiedJourneyStage(routingData?.journeyStage)
  const mostHelpfulNow = routingData?.mostHelpfulNow ?? []
  const hasSelections = mostHelpfulNow.length > 0
  const selectedOnlyNotSure = mostHelpfulNow.length === 1 && mostHelpfulNow.includes(HelpfulOption.NOT_SURE)
  const selectedOnlyFinanceInfo = mostHelpfulNow.length === 1 && mostHelpfulNow.includes(HelpfulOption.FINANCE_INFO)
  const selectedOnlyNotSureAndFinanceInfo =
    mostHelpfulNow.length === 2 &&
    mostHelpfulNow.includes(HelpfulOption.NOT_SURE) &&
    mostHelpfulNow.includes(HelpfulOption.FINANCE_INFO)

  return (
    ivfRequirementsApply &&
    isAssistedReproduction &&
    isQualifyingStage &&
    hasSelections &&
    !selectedOnlyNotSure &&
    !selectedOnlyFinanceInfo &&
    !selectedOnlyNotSureAndFinanceInfo
  )
}

export default function GoalTimeframeDecisionStep(): JSX.Element {
  const routingData = useCheckRoutingInfoQueryCache()
  const { data: benefit, isLoading: isBenefitLoading } = useBenefit()
  const { send } = useStateMachine()

  const ivfRequirementsApply = benefit?.journeys?.fertilityCare?.eligibleExpensesDetail?.ivfRequirementsApply ?? false

  useEffect(() => {
    if (routingData && !isBenefitLoading) {
      send(shouldShowGoalTimeframe(routingData, ivfRequirementsApply) ? "SHOW" : "SKIP")
    }
  })

  return <></>
}
